import serverInterface from 'server-interface';

import PageResultRow from '../page-result-row';

class PageSearchStrategy {

  async search(searchTerm) {

    const response = await serverInterface.startup.pages.getPagesBySearchTerm(searchTerm);

    const results = response.map(function mapPage(page) {
      return {
        type: 'PAGE',
        data: page
      };
    });

    return results;

  }

  async loadRecentSearchResults() {

    const response = await serverInterface.startup.recentSearchResults.getRecentSearchResults('PAGE');

    return response;

  }

  getResultComponentClass() {

    return PageResultRow;

  }

  getNavigationPath(data) {

    return `/pages/${data._id}`;

  }

  prepareDataForStorage(data) {

    return data;

  }

}

export default PageSearchStrategy;